import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import {
  SITE_POSTER_CODE_ANCHOR_X,
  SITE_POSTER_CODE_FONT_SIZE_PT,
  formatSitePosterProjectCodeLine,
  getSitePosterCodeBaselineFromTop,
  sitePosterYFromTopToPdfLib,
} from './sitePosterConfig';

/** pdf-lib can detach the underlying ArrayBuffer; keep preview bytes separate. */
function cloneTemplateBytes(templateBytes) {
  if (templateBytes instanceof Uint8Array) {
    return new Uint8Array(templateBytes);
  }
  const buf = templateBytes instanceof ArrayBuffer ? templateBytes : templateBytes.buffer;
  return new Uint8Array(buf.slice(0));
}

/**
 * Stamp project code onto the global site poster template (client-side).
 * @param {Uint8Array | ArrayBuffer} templateBytes
 * @param {string} projectCode
 * @returns {Promise<Uint8Array>}
 */
export async function generateSitePosterPdf(templateBytes, projectCode) {
  const code = String(projectCode || '').trim();
  if (!code) {
    throw new Error('This project does not have a project code yet. Add one in project settings.');
  }

  const pdfDoc = await PDFDocument.load(cloneTemplateBytes(templateBytes));
  const pages = pdfDoc.getPages();
  if (pages.length === 0) {
    throw new Error('Site poster template has no pages.');
  }
  const page = pages[0];
  const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
  const fontSize = SITE_POSTER_CODE_FONT_SIZE_PT;
  const line = formatSitePosterProjectCodeLine(code);
  const textWidth = font.widthOfTextAtSize(line, fontSize);
  const x = SITE_POSTER_CODE_ANCHOR_X - textWidth / 2;
  const y = sitePosterYFromTopToPdfLib(getSitePosterCodeBaselineFromTop(fontSize));

  page.drawText(line, {
    x,
    y,
    size: fontSize,
    font,
    color: rgb(0, 0, 0),
  });

  return pdfDoc.save();
}
